import React from 'react';
import InputMain from '../../Main/InputMain';
import PaginationMain from '../../Main/PaginationMain';
import _ from 'lodash';
import { filterData } from '../../../../utils/function';

const columns = [
    { id: 'check', label: 'Sel.', width: 50, align: 'center', },
    { id: 'nombre', label: 'Nombre', width: 100, align: 'left', },
    { id: 'marca', label: 'Marca', width: 100, align: 'center', },
    { id: 'modelo', label: 'Modelo', width: 100, align: 'center', },
    { id: 'nroSerie', label: 'Serie', width: 100, align: 'center', },
    { id: 'imei', label: 'IMEI', width: 100, align: 'center', },
    { id: 'estadoEqp_id', label: 'Estado Eqp', width: 100, align: 'center', },
    { id: 'categoria_id', label: 'Categoria', width: 100, align: 'center', },
];
const columnsMap = {
    estado_id: 'estado.desEstado',
    estadoEqp_id: 'estadoEqp.descripcion',
    proveedor_id: 'proveedor.nombre',
    categoria_id: 'categoria.nombre'
};
function getValueFromPath(obj, path) {
    const pathArray = path.split('.');
    let value = obj;
    for (const key of pathArray) {
        if (value === null || value === undefined) {
            return ''; // O algún valor por defecto
        }
        value = value[key];
    }
    return value;
}

const SearchEquipment = ({ maxHeight = 50, data, search, setSearch, page, setPage, totalPages, getEquipment, setInfoEquipment }) => {
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            getEquipment();
        }
    };
    return (
        <div className="container" style={{ maxHeight: `${maxHeight}vh`, overflow: 'scroll' }}>
            <div className='d-flex align-items-end'>
                <InputMain
                    title={'Buscar equipo'}
                    placeholder={'Buscar equipo (nombre, serial, imei)'}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyPress={handleKeyPress}
                />
                <button type="button" className="btn btn-outline-dark btn-sm mb-1 btn-group-custom" onClick={getEquipment}><i className="fa-solid fa-magnifying-glass"></i></button>
            </div>
            <div className='body-table body-table__modal table-responsive' style={{ maxHeight: `${maxHeight / 1.5}vh` }}>
                <div className="container">
                    <div className="body-table-wrapper mt-3" style={{ maxHeight: `${maxHeight / 2}vh` }}>
                        <table className="table table-bordered table-hover table-sm">
                            <thead className="table-dark sticky-top">
                                <tr>
                                    {columns.map((col) => (
                                        <th
                                            scope="col"
                                            key={col.id}
                                            style={{
                                                textAlign: col.align,
                                                width: `${col.width}px`,
                                                maxWidth: `${col.width}px`,
                                            }}
                                        >
                                            {col.label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data?.map((row, idx) => {
                                    return (
                                        <tr key={idx}>
                                            {columns.map((col) => {
                                                const value = col.id in columnsMap ? getValueFromPath(row, columnsMap[col.id]) : row[col.id];
                                                return (
                                                    <td
                                                        key={col.id}
                                                        style={{
                                                            textAlign: col.align,
                                                            width: `${col.width}px`,
                                                            maxWidth: `${col.width}px`,
                                                        }}
                                                    >
                                                        {col.id === 'check' ?
                                                            <button type="button" className="btn btn-outline-dark btn-sm buttons-grid" onClick={() => setInfoEquipment(row)}>
                                                                <i className="fa-regular fa-square-check"></i>
                                                            </button>
                                                            : (col.type === 'number' && col.format) ? col.format(value) : value
                                                        }
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
                <PaginationMain
                    size={'small'}
                    totalPages={totalPages}
                    page={page}
                    setPage={setPage}
                />
            </div>
        </div>
    )
}

export default SearchEquipment;